// frontend/src/utils/mockData.js
// Datos de demostración completos para el modo sin base de datos

// ==================== USUARIOS DEMO ====================
export const DEMO_USERS = {
  'admin@demo.com': {
    id_usuario: 1,
    email: 'admin@demo.com',
    password: 'demo123',
    nombre: 'Carlos Mendoza',
    rut: '12.345.678-9',
    estado: 'ACTIVO',
    telefono: '+56 9 1234 5678',
    direccion: 'Av. Providencia 1234, Of. 501',
    comuna: 'Providencia',
    ciudad: 'Santiago',
    fecha_registro: '2025-06-15',
    id_empresa: 1,
    empresa: { id_empresa: 1, nombre: 'TechSolutions Chile SpA', rut: '76.543.210-K' },
    rol: { id_rol: 1, nombre: 'ADMIN', descripcion: 'Administrador del sistema' }
  },
  'jefe@demo.com': {
    id_usuario: 2,
    email: 'jefe@demo.com',
    password: 'demo123',
    nombre: 'María Fernández',
    rut: '11.222.333-4',
    estado: 'ACTIVO',
    telefono: '+56 9 8765 4321',
    direccion: 'Calle Los Leones 567',
    comuna: 'Las Condes',
    ciudad: 'Santiago',
    fecha_registro: '2025-07-20',
    id_empresa: 1,
    empresa: { id_empresa: 1, nombre: 'TechSolutions Chile SpA', rut: '76.543.210-K' },
    rol: { id_rol: 2, nombre: 'JEFE', descripcion: 'Jefe de proyecto' }
  },
  'colaborador@demo.com': {
    id_usuario: 3,
    email: 'colaborador@demo.com',
    password: 'demo123',
    nombre: 'Juan Pérez',
    rut: '15.666.777-8',
    estado: 'ACTIVO',
    telefono: '+56 9 5555 6666',
    direccion: 'Pasaje El Roble 89',
    comuna: 'Ñuñoa',
    ciudad: 'Santiago',
    fecha_registro: '2025-08-10',
    id_empresa: 1,
    empresa: { id_empresa: 1, nombre: 'TechSolutions Chile SpA', rut: '76.543.210-K' },
    rol: { id_rol: 3, nombre: 'COLABORADOR', descripcion: 'Colaborador de proyecto' }
  }
};

// ==================== ESTADÍSTICAS ADMIN ====================
export const ADMIN_STATS = {
  totalUsuarios: 15,
  usuariosActivos: 12,
  usuariosInactivos: 3,
  totalProyectos: 6,
  proyectosActivos: 4,
  proyectosCompletados: 1,
  proyectosPendientes: 1,
  totalTareas: 52,
  tareasCompletadas: 31,
  tareasEnProgreso: 14,
  tareasPendientes: 5,
  tareasEnRevision: 2,
  pagosPendientes: 4,
  pagosRealizados: 18,
  montoTotalPagado: 15840000,
  montoPendiente: 3520000,
  horasTrabajadas: 1056,
  promedioCompletitud: 78
};

// ==================== PROYECTOS ====================
export const PROYECTOS = [
  {
    id_proyecto: 1,
    nombre_proyecto: 'Portal E-Commerce Premium',
    descripcion: 'Desarrollo de plataforma e-commerce con carrito de compras, pasarela de pagos integrada, sistema de inventario y panel de administración completo.',
    fecha_inicio: '2026-01-15',
    fecha_fin: '2026-05-30',
    estado: 'ACTIVO',
    etapa_actual: 'Desarrollo',
    jefe_proyecto: { id: 2, nombre: 'María Fernández' },
    colaboradores: [3, 4, 5, 8],
    tareas_completadas: 18,
    tareas_totales: 24,
    progreso: 75,
    presupuesto: 8500000,
    horas_estimadas: 320,
    horas_trabajadas: 245,
    prioridad: 'ALTA',
    cliente: 'Comercial Los Andes Ltda.'
  },
  {
    id_proyecto: 2,
    nombre_proyecto: 'App Móvil Delivery',
    descripcion: 'Aplicación móvil nativa para iOS y Android de servicio de delivery con seguimiento en tiempo real, notificaciones push y sistema de calificaciones.',
    fecha_inicio: '2026-02-01',
    fecha_fin: '2026-06-15',
    estado: 'ACTIVO',
    etapa_actual: 'Testing',
    jefe_proyecto: { id: 2, nombre: 'María Fernández' },
    colaboradores: [3, 6, 7],
    tareas_completadas: 28,
    tareas_totales: 32,
    progreso: 88,
    presupuesto: 12000000,
    horas_estimadas: 480,
    horas_trabajadas: 412,
    prioridad: 'ALTA',
    cliente: 'FastFood Express S.A.'
  },
  {
    id_proyecto: 3,
    nombre_proyecto: 'Sistema de Gestión RRHH',
    descripcion: 'Sistema integral de recursos humanos con gestión de nóminas, control de asistencia, evaluaciones de desempeño y portal del empleado.',
    fecha_inicio: '2026-03-01',
    fecha_fin: '2026-08-30',
    estado: 'ACTIVO',
    etapa_actual: 'Análisis',
    jefe_proyecto: { id: 9, nombre: 'Andrés Soto' },
    colaboradores: [4, 5, 10],
    tareas_completadas: 5,
    tareas_totales: 28,
    progreso: 18,
    presupuesto: 15000000,
    horas_estimadas: 600,
    horas_trabajadas: 85,
    prioridad: 'MEDIA',
    cliente: 'Grupo Industrial Norte'
  },
  {
    id_proyecto: 4,
    nombre_proyecto: 'Migración Cloud AWS',
    descripcion: 'Migración completa de infraestructura on-premise a servicios cloud de AWS incluyendo EC2, RDS, S3 y configuración de CI/CD.',
    fecha_inicio: '2026-01-10',
    fecha_fin: '2026-04-20',
    estado: 'ACTIVO',
    etapa_actual: 'Implementación',
    jefe_proyecto: { id: 2, nombre: 'María Fernández' },
    colaboradores: [3, 7, 8],
    tareas_completadas: 19,
    tareas_totales: 22,
    progreso: 86,
    presupuesto: 6500000,
    horas_estimadas: 240,
    horas_trabajadas: 198,
    prioridad: 'ALTA',
    cliente: 'Interno'
  },
  {
    id_proyecto: 5,
    nombre_proyecto: 'Dashboard Analytics',
    descripcion: 'Panel de visualización de datos con gráficos interactivos, reportes automatizados y exportación a múltiples formatos.',
    fecha_inicio: '2026-02-15',
    fecha_fin: '2026-04-15',
    estado: 'COMPLETADO',
    etapa_actual: 'Completado',
    jefe_proyecto: { id: 2, nombre: 'María Fernández' },
    colaboradores: [3, 6],
    tareas_completadas: 16,
    tareas_totales: 16,
    progreso: 100,
    presupuesto: 4200000,
    horas_estimadas: 160,
    horas_trabajadas: 152,
    prioridad: 'MEDIA',
    cliente: 'DataCorp Chile'
  },
  {
    id_proyecto: 6,
    nombre_proyecto: 'Integración API Bancaria',
    descripcion: 'Desarrollo de módulo de integración con APIs bancarias para consulta de saldos, transferencias y conciliación automática.',
    fecha_inicio: '2026-05-01',
    fecha_fin: '2026-07-30',
    estado: 'PENDIENTE',
    etapa_actual: 'Planificación',
    jefe_proyecto: { id: 9, nombre: 'Andrés Soto' },
    colaboradores: [],
    tareas_completadas: 0,
    tareas_totales: 18,
    progreso: 0,
    presupuesto: 7800000,
    horas_estimadas: 280,
    horas_trabajadas: 0,
    prioridad: 'ALTA',
    cliente: 'FinTech Solutions'
  }
];

// ==================== TAREAS ====================
export const TAREAS = [
  // Tareas del proyecto 1 - Portal E-Commerce
  {
    id: 1,
    id_tarea: 1,
    nombre: 'Diseño UI/UX página principal',
    descripcion: 'Crear mockups y prototipos interactivos para la landing page del e-commerce',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-01-20',
    fecha_entrega: '2026-02-05',
    fecha_completado: '2026-02-03',
    id_proyecto: 1,
    proyecto: { nombre: 'Portal E-Commerce Premium' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'ALTA',
    horas_estimadas: 24,
    horas_trabajadas: 22,
    comentarios: 3,
    archivos_adjuntos: 2
  },
  {
    id: 2,
    id_tarea: 2,
    nombre: 'Implementar carrito de compras',
    descripcion: 'Desarrollar funcionalidad completa del carrito con persistencia en localStorage y sincronización con backend',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-02-06',
    fecha_entrega: '2026-02-28',
    fecha_completado: '2026-02-25',
    id_proyecto: 1,
    proyecto: { nombre: 'Portal E-Commerce Premium' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'ALTA',
    horas_estimadas: 40,
    horas_trabajadas: 38,
    comentarios: 5,
    archivos_adjuntos: 0
  },
  {
    id: 3,
    id_tarea: 3,
    nombre: 'Integrar pasarela de pagos',
    descripcion: 'Conectar con Transbank/MercadoPago para procesamiento de pagos con tarjetas',
    estado: 'EN_PROGRESO',
    fecha_creacion: '2026-03-01',
    fecha_entrega: '2026-04-15',
    id_proyecto: 1,
    proyecto: { nombre: 'Portal E-Commerce Premium' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'ALTA',
    horas_estimadas: 32,
    horas_trabajadas: 18,
    comentarios: 2,
    archivos_adjuntos: 1
  },
  {
    id: 4,
    id_tarea: 4,
    nombre: 'Sistema de gestión de inventario',
    descripcion: 'Panel admin para control de stock, alertas de bajo inventario y reportes',
    estado: 'EN_REVISION',
    fecha_creacion: '2026-02-15',
    fecha_entrega: '2026-04-01',
    id_proyecto: 1,
    proyecto: { nombre: 'Portal E-Commerce Premium' },
    asignado_a: 4,
    colaborador: { nombre: 'Ana García' },
    prioridad: 'MEDIA',
    horas_estimadas: 48,
    horas_trabajadas: 45,
    comentarios: 4,
    archivos_adjuntos: 3
  },
  {
    id: 5,
    id_tarea: 5,
    nombre: 'Optimización SEO',
    descripcion: 'Implementar meta tags, sitemap, schema markup y optimización de performance',
    estado: 'PENDIENTE',
    fecha_creacion: '2026-03-20',
    fecha_entrega: '2026-05-01',
    id_proyecto: 1,
    proyecto: { nombre: 'Portal E-Commerce Premium' },
    asignado_a: 5,
    colaborador: { nombre: 'Pedro López' },
    prioridad: 'BAJA',
    horas_estimadas: 16,
    horas_trabajadas: 0,
    comentarios: 0,
    archivos_adjuntos: 0
  },
  // Tareas del proyecto 2 - App Móvil Delivery
  {
    id: 6,
    id_tarea: 6,
    nombre: 'Diseño interfaz app cliente',
    descripcion: 'Diseño completo de todas las pantallas para la app del cliente final',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-02-05',
    fecha_entrega: '2026-02-25',
    fecha_completado: '2026-02-23',
    id_proyecto: 2,
    proyecto: { nombre: 'App Móvil Delivery' },
    asignado_a: 6,
    colaborador: { nombre: 'Sofía Martínez' },
    prioridad: 'ALTA',
    horas_estimadas: 32,
    horas_trabajadas: 30,
    comentarios: 6,
    archivos_adjuntos: 8
  },
  {
    id: 7,
    id_tarea: 7,
    nombre: 'Módulo de seguimiento GPS',
    descripcion: 'Implementar tracking en tiempo real del repartidor con mapa interactivo',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-02-26',
    fecha_entrega: '2026-03-20',
    fecha_completado: '2026-03-18',
    id_proyecto: 2,
    proyecto: { nombre: 'App Móvil Delivery' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'ALTA',
    horas_estimadas: 48,
    horas_trabajadas: 52,
    comentarios: 8,
    archivos_adjuntos: 2
  },
  {
    id: 8,
    id_tarea: 8,
    nombre: 'Sistema de notificaciones push',
    descripcion: 'Configurar Firebase Cloud Messaging para notificaciones en iOS y Android',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-03-01',
    fecha_entrega: '2026-03-25',
    fecha_completado: '2026-03-24',
    id_proyecto: 2,
    proyecto: { nombre: 'App Móvil Delivery' },
    asignado_a: 7,
    colaborador: { nombre: 'Diego Fernández' },
    prioridad: 'MEDIA',
    horas_estimadas: 24,
    horas_trabajadas: 26,
    comentarios: 3,
    archivos_adjuntos: 1
  },
  {
    id: 9,
    id_tarea: 9,
    nombre: 'Testing QA completo',
    descripcion: 'Pruebas de integración, usabilidad y performance en dispositivos reales',
    estado: 'EN_PROGRESO',
    fecha_creacion: '2026-03-25',
    fecha_entrega: '2026-04-20',
    id_proyecto: 2,
    proyecto: { nombre: 'App Móvil Delivery' },
    asignado_a: 6,
    colaborador: { nombre: 'Sofía Martínez' },
    prioridad: 'ALTA',
    horas_estimadas: 40,
    horas_trabajadas: 28,
    comentarios: 12,
    archivos_adjuntos: 5
  },
  // Tareas del proyecto 4 - Migración Cloud
  {
    id: 10,
    id_tarea: 10,
    nombre: 'Configurar VPC y subredes AWS',
    descripcion: 'Diseñar arquitectura de red en AWS con subredes públicas y privadas',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-01-15',
    fecha_entrega: '2026-01-30',
    fecha_completado: '2026-01-28',
    id_proyecto: 4,
    proyecto: { nombre: 'Migración Cloud AWS' },
    asignado_a: 7,
    colaborador: { nombre: 'Diego Fernández' },
    prioridad: 'ALTA',
    horas_estimadas: 16,
    horas_trabajadas: 14,
    comentarios: 2,
    archivos_adjuntos: 4
  },
  {
    id: 11,
    id_tarea: 11,
    nombre: 'Migrar base de datos a RDS',
    descripcion: 'Migrar PostgreSQL on-premise a Amazon RDS con replicación',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-02-01',
    fecha_entrega: '2026-02-20',
    fecha_completado: '2026-02-18',
    id_proyecto: 4,
    proyecto: { nombre: 'Migración Cloud AWS' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'ALTA',
    horas_estimadas: 32,
    horas_trabajadas: 35,
    comentarios: 6,
    archivos_adjuntos: 2
  },
  {
    id: 12,
    id_tarea: 12,
    nombre: 'Configurar pipeline CI/CD',
    descripcion: 'Implementar GitHub Actions para deploy automático a ECS',
    estado: 'EN_REVISION',
    fecha_creacion: '2026-02-21',
    fecha_entrega: '2026-03-15',
    id_proyecto: 4,
    proyecto: { nombre: 'Migración Cloud AWS' },
    asignado_a: 8,
    colaborador: { nombre: 'Camila Rodríguez' },
    prioridad: 'MEDIA',
    horas_estimadas: 24,
    horas_trabajadas: 22,
    comentarios: 4,
    archivos_adjuntos: 1
  },
  {
    id: 13,
    id_tarea: 13,
    nombre: 'Documentación técnica infraestructura',
    descripcion: 'Crear documentación detallada de la arquitectura cloud implementada',
    estado: 'EN_PROGRESO',
    fecha_creacion: '2026-03-01',
    fecha_entrega: '2026-04-10',
    id_proyecto: 4,
    proyecto: { nombre: 'Migración Cloud AWS' },
    asignado_a: 3,
    colaborador: { nombre: 'Juan Pérez' },
    prioridad: 'MEDIA',
    horas_estimadas: 16,
    horas_trabajadas: 8,
    comentarios: 1,
    archivos_adjuntos: 0
  },
  // Tareas adicionales para variedad
  {
    id: 14,
    id_tarea: 14,
    nombre: 'Análisis de requerimientos RRHH',
    descripcion: 'Levantamiento de procesos actuales y definición de funcionalidades',
    estado: 'COMPLETADO',
    fecha_creacion: '2026-03-05',
    fecha_entrega: '2026-03-20',
    fecha_completado: '2026-03-19',
    id_proyecto: 3,
    proyecto: { nombre: 'Sistema de Gestión RRHH' },
    asignado_a: 4,
    colaborador: { nombre: 'Ana García' },
    prioridad: 'ALTA',
    horas_estimadas: 24,
    horas_trabajadas: 26,
    comentarios: 8,
    archivos_adjuntos: 6
  },
  {
    id: 15,
    id_tarea: 15,
    nombre: 'Diseño base de datos RRHH',
    descripcion: 'Modelado de entidades y relaciones para el sistema de recursos humanos',
    estado: 'EN_PROGRESO',
    fecha_creacion: '2026-03-21',
    fecha_entrega: '2026-04-15',
    id_proyecto: 3,
    proyecto: { nombre: 'Sistema de Gestión RRHH' },
    asignado_a: 5,
    colaborador: { nombre: 'Pedro López' },
    prioridad: 'ALTA',
    horas_estimadas: 32,
    horas_trabajadas: 18,
    comentarios: 3,
    archivos_adjuntos: 2
  }
];

// ==================== USUARIOS DEL SISTEMA ====================
export const USUARIOS_SISTEMA = [
  { id_usuario: 1, nombre: 'Carlos Mendoza', email: 'admin@demo.com', rut: '12.345.678-9', rol: 'ADMIN', id_rol: 1, estado: 'ACTIVO', fecha_registro: '2025-06-15', proyectos: 6, telefono: '+56 9 1234 5678' },
  { id_usuario: 2, nombre: 'María Fernández', email: 'jefe@demo.com', rut: '11.222.333-4', rol: 'JEFE', id_rol: 2, estado: 'ACTIVO', fecha_registro: '2025-07-20', proyectos: 4, telefono: '+56 9 8765 4321' },
  { id_usuario: 3, nombre: 'Juan Pérez', email: 'colaborador@demo.com', rut: '15.666.777-8', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 3, tarifa: { id_tarifa: 3, nombre_tarifa: 'Senior', monto: 18000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-08-10', proyectos: 4, telefono: '+56 9 5555 6666' },
  { id_usuario: 4, nombre: 'Ana García', email: 'ana.garcia@demo.com', rut: '14.555.444-3', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 2, tarifa: { id_tarifa: 2, nombre_tarifa: 'Semi-Senior', monto: 16000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-08-15', proyectos: 2, telefono: '+56 9 4444 3333' },
  { id_usuario: 5, nombre: 'Pedro López', email: 'pedro.lopez@demo.com', rut: '13.444.333-2', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 3, tarifa: { id_tarifa: 3, nombre_tarifa: 'Senior', monto: 18000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-09-01', proyectos: 2, telefono: '+56 9 3333 2222' },
  { id_usuario: 6, nombre: 'Sofía Martínez', email: 'sofia.martinez@demo.com', rut: '16.777.888-1', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 5, tarifa: { id_tarifa: 5, nombre_tarifa: 'Diseñador', monto: 15000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-09-10', proyectos: 2, telefono: '+56 9 2222 1111' },
  { id_usuario: 7, nombre: 'Diego Fernández', email: 'diego.fernandez@demo.com', rut: '17.888.999-0', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 3, tarifa: { id_tarifa: 3, nombre_tarifa: 'Senior', monto: 18000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-09-20', proyectos: 3, telefono: '+56 9 1111 0000' },
  { id_usuario: 8, nombre: 'Camila Rodríguez', email: 'camila.rodriguez@demo.com', rut: '18.999.000-K', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 1, tarifa: { id_tarifa: 1, nombre_tarifa: 'Junior', monto: 12000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-10-01', proyectos: 2, telefono: '+56 9 9999 8888' },
  { id_usuario: 9, nombre: 'Andrés Soto', email: 'andres.soto@demo.com', rut: '10.111.222-3', rol: 'JEFE', id_rol: 2, estado: 'ACTIVO', fecha_registro: '2025-10-15', proyectos: 2, telefono: '+56 9 8888 7777' },
  { id_usuario: 10, nombre: 'Valentina Muñoz', email: 'valentina.munoz@demo.com', rut: '19.123.456-7', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 1, tarifa: { id_tarifa: 1, nombre_tarifa: 'Junior', monto: 12000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-11-01', proyectos: 1, telefono: '+56 9 7777 6666' },
  { id_usuario: 11, nombre: 'Roberto Silva', email: 'roberto.silva@demo.com', rut: '11.345.678-9', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 2, tarifa: { id_tarifa: 2, nombre_tarifa: 'Semi-Senior', monto: 16000, moneda: 'CLP' }, estado: 'INACTIVO', fecha_registro: '2025-08-01', proyectos: 0, telefono: '+56 9 6666 5555' },
  { id_usuario: 12, nombre: 'Francisca Torres', email: 'francisca.torres@demo.com', rut: '12.456.789-0', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 3, tarifa: { id_tarifa: 3, nombre_tarifa: 'Senior', monto: 18000, moneda: 'CLP' }, estado: 'INACTIVO', fecha_registro: '2025-07-15', proyectos: 0, telefono: '+56 9 5555 4444' },
  { id_usuario: 13, nombre: 'Martín Vargas', email: 'martin.vargas@demo.com', rut: '20.234.567-8', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 4, tarifa: { id_tarifa: 4, nombre_tarifa: 'Lead', monto: 25000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2025-12-01', proyectos: 1, telefono: '+56 9 4444 3333' },
  { id_usuario: 14, nombre: 'Isabella Castro', email: 'isabella.castro@demo.com', rut: '21.345.678-9', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 5, tarifa: { id_tarifa: 5, nombre_tarifa: 'Diseñador', monto: 15000, moneda: 'CLP' }, estado: 'ACTIVO', fecha_registro: '2026-01-10', proyectos: 1, telefono: '+56 9 3333 2222' },
  { id_usuario: 15, nombre: 'Lucas Herrera', email: 'lucas.herrera@demo.com', rut: '13.567.890-1', rol: 'COLABORADOR', id_rol: 3, id_tarifa: 1, tarifa: { id_tarifa: 1, nombre_tarifa: 'Junior', monto: 12000, moneda: 'CLP' }, estado: 'INACTIVO', fecha_registro: '2025-06-01', proyectos: 0, telefono: '+56 9 2222 1111' }
];

// ==================== INVITACIONES JEFE ====================
export const INVITACIONES_JEFE = [
  {
    id: 1,
    proyecto: { id_proyecto: 6, nombre: 'Integración API Bancaria' },
    fecha_invitacion: '2026-04-02',
    estado: 'PENDIENTE',
    invitado_por: 'Carlos Mendoza',
    mensaje: 'Te invitamos a liderar este proyecto de integración bancaria. Es un cliente importante.',
    fecha_limite_respuesta: '2026-04-10'
  }
];

// ==================== TAREAS PARA REVISIÓN JEFE ====================
export const TAREAS_JEFE = [
  {
    id: 4,
    nombre: 'Sistema de gestión de inventario',
    descripcion: 'Panel admin para control de stock, alertas de bajo inventario y reportes',
    estado: 'EN_REVISION',
    fecha_creacion: '2026-02-15',
    fecha_entrega: '2026-04-01',
    fecha_envio_revision: '2026-03-28',
    proyecto: { id: 1, nombre: 'Portal E-Commerce Premium' },
    colaborador: { id: 4, nombre: 'Ana García', email: 'ana.garcia@demo.com' },
    prioridad: 'MEDIA',
    horas_trabajadas: 45,
    archivos_entrega: [
      { nombre: 'inventario_modulo.zip', tamano: '2.4 MB' },
      { nombre: 'documentacion.pdf', tamano: '856 KB' }
    ],
    comentario_colaborador: 'Módulo completado con todas las funcionalidades solicitadas. Incluye alertas automáticas cuando el stock baja del mínimo configurado.'
  },
  {
    id: 12,
    nombre: 'Configurar pipeline CI/CD',
    descripcion: 'Implementar GitHub Actions para deploy automático a ECS',
    estado: 'EN_REVISION',
    fecha_creacion: '2026-02-21',
    fecha_entrega: '2026-03-15',
    fecha_envio_revision: '2026-03-14',
    proyecto: { id: 4, nombre: 'Migración Cloud AWS' },
    colaborador: { id: 8, nombre: 'Camila Rodríguez', email: 'camila.rodriguez@demo.com' },
    prioridad: 'MEDIA',
    horas_trabajadas: 22,
    archivos_entrega: [
      { nombre: 'github-workflows.zip', tamano: '124 KB' },
      { nombre: 'readme_cicd.md', tamano: '12 KB' }
    ],
    comentario_colaborador: 'Pipeline configurado con stages de build, test y deploy. Incluye rollback automático en caso de fallo.'
  }
];

// ==================== PAGOS ====================
export const PAGOS = [
  { id: 1, id_colaborador: 3, colaborador: 'Juan Pérez', proyecto: 'Portal E-Commerce Premium', monto: 880000, estado: 'PENDIENTE', fecha: '2026-04-05', periodo: 'Marzo 2026', horas: 48, tarifa: 18000 },
  { id: 2, id_colaborador: 4, colaborador: 'Ana García', proyecto: 'Portal E-Commerce Premium', monto: 720000, estado: 'PENDIENTE', fecha: '2026-04-05', periodo: 'Marzo 2026', horas: 45, tarifa: 16000 },
  { id: 3, id_colaborador: 7, colaborador: 'Diego Fernández', proyecto: 'Migración Cloud AWS', monto: 540000, estado: 'PENDIENTE', fecha: '2026-04-05', periodo: 'Marzo 2026', horas: 30, tarifa: 18000 },
  { id: 4, id_colaborador: 6, colaborador: 'Sofía Martínez', proyecto: 'App Móvil Delivery', monto: 640000, estado: 'PENDIENTE', fecha: '2026-04-05', periodo: 'Marzo 2026', horas: 40, tarifa: 16000 },
  { id: 5, id_colaborador: 3, colaborador: 'Juan Pérez', proyecto: 'Migración Cloud AWS', monto: 756000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-08', periodo: 'Febrero 2026', horas: 42, tarifa: 18000 },
  { id: 6, id_colaborador: 3, colaborador: 'Juan Pérez', proyecto: 'App Móvil Delivery', monto: 936000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-07', periodo: 'Febrero 2026', horas: 52, tarifa: 18000 },
  { id: 7, id_colaborador: 6, colaborador: 'Sofía Martínez', proyecto: 'App Móvil Delivery', monto: 480000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-08', periodo: 'Febrero 2026', horas: 30, tarifa: 16000 },
  { id: 8, id_colaborador: 7, colaborador: 'Diego Fernández', proyecto: 'Migración Cloud AWS', monto: 612000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-06', periodo: 'Febrero 2026', horas: 34, tarifa: 18000 },
  { id: 9, id_colaborador: 4, colaborador: 'Ana García', proyecto: 'Portal E-Commerce Premium', monto: 560000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-07', periodo: 'Febrero 2026', horas: 35, tarifa: 16000 },
  { id: 10, id_colaborador: 8, colaborador: 'Camila Rodríguez', proyecto: 'Migración Cloud AWS', monto: 432000, estado: 'PAGADO', fecha: '2026-03-05', fecha_pago: '2026-03-08', periodo: 'Febrero 2026', horas: 24, tarifa: 18000 }
];

// ==================== PROYECTOS DEL COLABORADOR ====================
export const PROYECTOS_COLABORADOR = {
  solicitudes: [
    {
      id: 1,
      id_proyecto: 6,
      nombre_proyecto: 'Integración API Bancaria',
      descripcion: 'Desarrollo de módulo de integración con APIs bancarias',
      jefe: 'Andrés Soto',
      fecha_invitacion: '2026-04-03',
      fecha_inicio_proyecto: '2026-05-01',
      estado_invitacion: 'PENDIENTE'
    }
  ],
  aceptados: [
    {
      id_proyecto: 1,
      nombre_proyecto: 'Portal E-Commerce Premium',
      descripcion: 'Desarrollo de plataforma e-commerce completa',
      estado: 'ACTIVO',
      jefe: 'María Fernández',
      fecha_inicio: '2026-01-15',
      fecha_fin: '2026-05-30',
      mis_tareas: 3,
      tareas_completadas: 2,
      progreso_personal: 67
    },
    {
      id_proyecto: 2,
      nombre_proyecto: 'App Móvil Delivery',
      descripcion: 'Aplicación móvil nativa para servicio de delivery',
      estado: 'ACTIVO',
      jefe: 'María Fernández',
      fecha_inicio: '2026-02-01',
      fecha_fin: '2026-06-15',
      mis_tareas: 1,
      tareas_completadas: 1,
      progreso_personal: 100
    },
    {
      id_proyecto: 4,
      nombre_proyecto: 'Migración Cloud AWS',
      descripcion: 'Migración de infraestructura on-premise a AWS',
      estado: 'ACTIVO',
      jefe: 'María Fernández',
      fecha_inicio: '2026-01-10',
      fecha_fin: '2026-04-20',
      mis_tareas: 2,
      tareas_completadas: 1,
      progreso_personal: 50
    },
    {
      id_proyecto: 5,
      nombre_proyecto: 'Dashboard Analytics',
      descripcion: 'Panel de visualización de datos con gráficos interactivos',
      estado: 'COMPLETADO',
      jefe: 'María Fernández',
      fecha_inicio: '2026-02-15',
      fecha_fin: '2026-04-15',
      mis_tareas: 2,
      tareas_completadas: 2,
      progreso_personal: 100
    }
  ]
};

// ==================== TARIFAS ====================
export const TARIFAS = [
  { id: 1, nombre_tarifa: 'Junior', descripcion: 'Desarrolladores con menos de 2 años de experiencia', monto: 12000, moneda: 'CLP' },
  { id: 2, nombre_tarifa: 'Semi-Senior', descripcion: 'Desarrolladores con 2-4 años de experiencia', monto: 16000, moneda: 'CLP' },
  { id: 3, nombre_tarifa: 'Senior', descripcion: 'Desarrolladores con más de 4 años de experiencia', monto: 18000, moneda: 'CLP' },
  { id: 4, nombre_tarifa: 'Lead', descripcion: 'Líderes técnicos y arquitectos', monto: 25000, moneda: 'CLP' },
  { id: 5, nombre_tarifa: 'Diseñador', descripcion: 'Diseñadores UI/UX', monto: 15000, moneda: 'CLP' }
];

// ==================== SUSCRIPCIÓN ====================
export const SUSCRIPCION = {
  id: 1,
  plan: 'Profesional',
  estado: 'ACTIVA',
  fecha_inicio: '2026-01-01',
  fecha_fin: '2026-12-31',
  fecha_proximo_cobro: '2026-05-01',
  usuarios_max: 25,
  usuarios_actual: 15,
  proyectos_max: 20,
  proyectos_actual: 6,
  almacenamiento_max: '50 GB',
  almacenamiento_usado: '12.4 GB',
  precio_mensual: 79990,
  precio_anual: 799900,
  caracteristicas: [
    'Usuarios ilimitados en plan',
    'Hasta 20 proyectos activos',
    '50 GB de almacenamiento',
    'Reportes avanzados',
    'Soporte prioritario',
    'API access',
    'Integraciones'
  ],
  historial_pagos: [
    { id: 1, fecha: '2026-04-01', monto: 79990, estado: 'PAGADO', metodo: 'Tarjeta ****4532' },
    { id: 2, fecha: '2026-03-01', monto: 79990, estado: 'PAGADO', metodo: 'Tarjeta ****4532' },
    { id: 3, fecha: '2026-02-01', monto: 79990, estado: 'PAGADO', metodo: 'Tarjeta ****4532' },
    { id: 4, fecha: '2026-01-01', monto: 79990, estado: 'PAGADO', metodo: 'Tarjeta ****4532' }
  ]
};

// ==================== ACTIVIDAD RECIENTE ====================
export const ACTIVIDAD_RECIENTE = [
  { id: 1, tipo: 'tarea_completada', mensaje: 'Juan Pérez completó "Módulo de seguimiento GPS"', fecha: '2026-04-07 10:30', proyecto: 'App Móvil Delivery' },
  { id: 2, tipo: 'revision_enviada', mensaje: 'Ana García envió a revisión "Sistema de inventario"', fecha: '2026-04-07 09:15', proyecto: 'Portal E-Commerce Premium' },
  { id: 3, tipo: 'pago_realizado', mensaje: 'Se procesó pago de $756.000 a Juan Pérez', fecha: '2026-04-06 16:00', proyecto: 'Migración Cloud AWS' },
  { id: 4, tipo: 'usuario_agregado', mensaje: 'Isabella Castro fue agregada al equipo', fecha: '2026-04-06 11:20', proyecto: null },
  { id: 5, tipo: 'proyecto_actualizado', mensaje: 'Dashboard Analytics marcado como completado', fecha: '2026-04-05 18:45', proyecto: 'Dashboard Analytics' },
  { id: 6, tipo: 'comentario', mensaje: 'María Fernández comentó en "Testing QA completo"', fecha: '2026-04-05 14:30', proyecto: 'App Móvil Delivery' },
  { id: 7, tipo: 'tarea_asignada', mensaje: 'Nueva tarea asignada a Pedro López', fecha: '2026-04-04 10:00', proyecto: 'Portal E-Commerce Premium' },
  { id: 8, tipo: 'revision_aprobada', mensaje: 'Tarea "Configurar VPC" aprobada por María', fecha: '2026-04-03 15:20', proyecto: 'Migración Cloud AWS' }
];

// ==================== NOTIFICACIONES ====================
export const NOTIFICACIONES = [
  { id: 1, tipo: 'info', mensaje: 'Tienes 2 tareas pendientes de revisión', leida: false, fecha: '2026-04-07 08:00' },
  { id: 2, tipo: 'warning', mensaje: 'El proyecto "Portal E-Commerce" tiene tareas próximas a vencer', leida: false, fecha: '2026-04-06 17:00' },
  { id: 3, tipo: 'success', mensaje: 'Pago procesado correctamente', leida: true, fecha: '2026-04-06 16:00' },
  { id: 4, tipo: 'info', mensaje: 'Nueva invitación de proyecto recibida', leida: true, fecha: '2026-04-03 10:00' }
];

// ==================== CONFIGURACIÓN EMPRESA ====================
export const CONFIGURACION_EMPRESA = {
  nombre: 'TechSolutions Chile SpA',
  rut: '76.543.210-K',
  direccion: 'Av. Apoquindo 4500, Of. 1201',
  comuna: 'Las Condes',
  ciudad: 'Santiago',
  pais: 'Chile',
  telefono: '+56 2 2345 6789',
  email: 'contacto@techsolutions.cl',
  sitio_web: 'www.techsolutions.cl',
  logo_url: null,
  timezone: 'America/Santiago',
  moneda: 'CLP',
  formato_fecha: 'DD/MM/YYYY',
  dias_laborales: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
  hora_inicio: '09:00',
  hora_fin: '18:00'
};
